(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.innerWidth > 991) return;
    if (sessionStorage.getItem('nudge_shown')) return;
    if (window.location.pathname.indexOf('/collections/') === -1) return;

    sessionStorage.setItem('nudge_shown', '1');

    var firstCard = document.querySelector('.snippet-product-card');
    if (!firstCard) return;

    setTimeout(function () {
      firstCard.classList.add('snippet-product-card--nudge');
    }, 900);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-store-exclusive-url]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var url = btn.getAttribute('data-store-exclusive-url');
      if (url) {
        e.preventDefault();
        window.location.href = url;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
